import {GetSignableDocumentListResponseBody} from '@dms/api/core';

import {DocumentItemWithIsSelected} from '../types/DocumentItemWithIsSelected';

export const isDocumentItemWithFileId = (
  document: DocumentItemWithIsSelected | GetSignableDocumentListResponseBody
): document is DocumentItemWithIsSelected =>
  (document as DocumentItemWithIsSelected).fileId !== undefined;
